import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalBox = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  width: 560px;
  max-width: 90vw;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const ModalTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 19px;
  line-height: normal;
  color: #1a1a1a;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a4a4a;
  flex-shrink: 0;
`;

export const ModalBody = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #4a4a4a;
  margin: 0 0 32px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;

export const CancelBtn = styled.button`
  height: 32px;
  padding: 0 12px;
  background-color: #6b7280;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
`;

export const DeleteBtn = styled.button`
  height: 32px;
  padding: 0 12px;
  background-color: #cb282e;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
`;
